import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams({ email });
      await fetch('https://readdy.ai/api/form/d7cp56um3fsfopf23hlg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubscribed(true);
      setEmail('');
    } catch {
      setSubscribed(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#1a2e1a] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/3fc89005e5f8f541d0781d07714068dd/b31ed3570265bb91107b593ba40da4ad.jpeg"
                alt="金榜旺财"
                className="w-10 h-10 rounded-full object-cover"
              />
              <span className="font-bold text-lg text-amber-400">金榜旺财</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              专注高考与考研升学，打破城乡教育壁垒，让每一个孩子都能获得优质教育资源。
            </p>
            <div className="flex gap-3 mt-5">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-qq-line', 'ri-video-line'].map((icon) => (
                <div key={icon} className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-amber-500 transition-colors cursor-pointer">
                  <i className={`${icon} text-sm`}></i>
                </div>
              ))}
            </div>
          </div>

          {/* Subscribe */}
          <div>
            <h4 className="text-gray-300 text-xs uppercase tracking-widest mb-4">订阅最新资讯</h4>
            {subscribed ? (
              <p className="text-amber-400 text-sm">感谢订阅！我们会及时推送最新资讯。</p>
            ) : (
              <form data-readdy-form onSubmit={handleSubscribe} className="flex flex-col gap-3">
                <div className="flex items-center border-b border-gray-500 pb-2">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入您的邮箱"
                    className="flex-1 bg-transparent text-sm text-white placeholder-gray-500 outline-none"
                    required
                  />
                  <button type="submit" disabled={submitting} className="w-6 h-6 flex items-center justify-center cursor-pointer text-gray-400 hover:text-amber-400 transition-colors">
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
                <p className="text-gray-500 text-xs">订阅即可获取高考考研最新资讯</p>
              </form>
            )}
          </div>

          {/* Links */}
          <div>
            <h4 className="text-gray-300 text-xs uppercase tracking-widest mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: '首页', path: '/' },
                { label: '教学视频', path: '/videos' },
                { label: '互动交流', path: '/community' },
                { label: '在线商店', path: '/shop' },
                { label: '关于我们', path: '/about' },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-400 hover:text-amber-400 text-sm transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-gray-300 text-xs uppercase tracking-widest mb-4">联系我们</h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-mail-line text-amber-400"></i>
                contact@jinbangwangcai.com
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-phone-line text-amber-400"></i>
                400-888-8888
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-map-pin-line text-amber-400"></i>
                北京市海淀区中关村教育园
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-time-line text-amber-400"></i>
                周一至周日 8:00-22:00
              </li>
            </ul>
          </div>
        </div>

        {/* Big Brand Text */}
        <div className="border-t border-white/10 pt-8 overflow-hidden">
          <div className="text-center">
            <p className="text-[clamp(40px,8vw,100px)] font-black text-amber-400/20 tracking-tighter leading-none select-none">
              金榜旺财
            </p>
          </div>
          <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-2">
            <p className="text-gray-500 text-xs">© 2024 金榜旺财升学平台 版权所有</p>
            <div className="flex gap-4">
              <span className="text-gray-500 text-xs cursor-pointer hover:text-gray-300">隐私政策</span>
              <span className="text-gray-500 text-xs cursor-pointer hover:text-gray-300">用户协议</span>
              <span className="text-gray-500 text-xs cursor-pointer hover:text-gray-300">ICP备案号</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
